<dx-popup
	[width]="480"
	[height]="250"
	[showTitle]="true"
	[title]="title"
	[dragEnabled]="true"
	[hideOnOutsideClick]="hideOnOutsideClick"
	[showCloseButton]="false"
	[(visible)]="showResetConfirmationPopup"
>
	<div *dxTemplate="let data of 'content'">
		<div class="popup-container">
			<div class="row">
				<div class="col-lg-12 col-md-12">
					<span>{{ message }}</span>
				</div>
			</div>
			<div class="popup-btn-container">
				<app-goldstar-button *ngIf="!showCloseButton" [elementId]="elementIdPrefix + 'yes-btn'" (buttonClicked)="onConfirmation()" [color]="'#0f6cbd'" [borderColor]="'#0f6cbd'"
					>Yes</app-goldstar-button
				>
				<app-goldstar-button *ngIf="!showCloseButton" [elementId]="elementIdPrefix + 'no-btn'" (buttonClicked)="hidePopup()" [textColor]="'#0f6cbd'" color="#fff" [borderColor]="'#0f6cbd'"
					>No</app-goldstar-button
				>
				<app-goldstar-button
					*ngIf="showCloseButton"
					[elementId]="elementIdPrefix + 'close-btn'"
					(buttonClicked)="onConfirmation()"
					[textColor]="'#0f6cbd'"
					color="#fff"
					[borderColor]="'#0f6cbd'"
					>Close</app-goldstar-button
				>
			</div>
		</div>
	</div>
</dx-popup>
